module.exports = __webpack_public_path__ + "fonts/SamsungOne-600_v1.1.34bf7d64.ttf";